/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: prepostroll-resource-factory.js
 *
 * Created by rwilliams on 8/14/17.
 */

'use strict';

angular
.module('prism-ui.components.data')
.factory('PrePostRollResourceFactory', ($resource, EndPointService) => {
	return $resource(
	    `${EndPointService.prePostRollEndpoint}/:containerId`,
        {},
		{

		    //===============//
		    // Container API //
            //===============//

			update: {
				method: 'PUT'
			},


		    //===========//
		    // Asset API //
            //===========//

			createAsset: {
				method: 'POST',
				url: EndPointService.prePostRollEndpoint + '/:containerId/assets',
			},
			getAsset: {
				method: 'GET',
				url: `${EndPointService.prePostRollEndpoint}/assets/:assetId`
			},
			updateAsset: {
				method: 'PUT',
				url: `${EndPointService.prePostRollEndpoint}/assets/:assetId`
			},
            deleteAsset: {
			    method: 'DELETE',
                url: `${EndPointService.prePostRollEndpoint}/assets/:assetId`
            },


            //=====================//
            // Auxiliary Asset API //
            //=====================//

            //
            // These are used for sidecar audio and text tracks
            // which are associated with pre/post roll assets.
            //

			createAssetData: {
				method: 'POST',
				url: `${EndPointService.prePostRollEndpoint}/assets/:assetId/:subTypeKey`
			},
			updateAssetData: {
				method: 'PUT',
				url: `${EndPointService.prePostRollEndpoint}/assets/:subTypeKey/:subTypeId`
			},
			deleteAssetData: {
				method: 'DELETE',
				url: `${EndPointService.prePostRollEndpoint}/assets/:subTypeKey/:subTypeId`
			}
		});
});
